// extracted by mini-css-extract-plugin
module.exports = {"list":"TagList_list__IIeqw","item":"TagList_item__pTpwW","icon":"TagList_icon__txk1s","text":"TagList_text__mLuX2","count":"TagList_count__aHKby"};